import React, {useEffect, useState} from 'react'
import styled from 'styled-components'
import {Form} from 'react-bootstrap'
import {BooksitoutServer} from '../../../config/BooksitoutServer'
import toast from 'react-hot-toast'
import RowSpacer from '../../../common/styles/RowSpacer'
import NumberInput from '../../../common/form/NumberInput'
import {BookForm, BookLanguage, BookSource} from '../BookType'
import BookLanguageFormSelect from '../../../common/form/book/BookLanguageFormSelect'
import BookFormFormSelect from '../../../common/form/book/BookFormFormSelect'
import BookSourceFormSelect from '../../../common/form/book/BookSourceFormSelect'
import BooksitoutImages from '../../../images/BooksitoutImages'
import BookEditCoverModal from './BookEditCoverModal'
import BooksitoutButton from '../../../common/button/BooksitoutButton'
import Modal from '../../../common/Modal'
import useBookDetailStore from '../detail/useBookDetailStore'

interface Props {
	isOpen: boolean
	onClose: () => void
}

const BookEditModal: React.FC<Props> = ({isOpen, onClose}) => {
	const {book, updateBook} = useBookDetailStore()

	const [title, setTitle] = useState<string>('')
	const [author, setAuthor] = useState<string>('')
	const [endPage, setEndPage] = useState<string>('')
	const [isPublic, setIsPublic] = useState<boolean>(true)
	const [source, setSource] = useState<BookSource>('BUY_NEW_OFFLINE')
	const [form, setForm] = useState<BookForm>('PHYSICAL')
	const [language, setLanguage] = useState<BookLanguage>('KOREAN')
	const [isCoverModalOpen, setIsCoverModalOpen] = useState<boolean>(false)
	const [cover, setCover] = useState<string | null>('')

	useEffect(() => {
		if (book != null) {
			setTitle(book.title)
			setAuthor(book.author)
			setCover(book.cover)
			setEndPage(book.endPage.toString())
			setIsPublic(book.isPublic)
			setLanguage(book.language)
			setForm(book.form)
			setSource(book.source)
		}
	}, [book])

	const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault()

		BooksitoutServer
			.put(`/v1/book/${book!.id}`, {
				title,
				author,
				cover,
				page: endPage,
				isPublic,
				language,
				form,
				source,
			})
			.then(() => {
				toast.success('책을 수정했어요.')
				updateBook({title, author, cover, endPage: Number(endPage), isPublic, language, form, source})
				onClose()
			})
			.catch(() => toast.error('오류가 났어요. 잠시 후 다시 시도해 주세요.'))
	}

	return (
		<>
			{isCoverModalOpen && (
				<BookEditCoverModal
					isOpen={isCoverModalOpen}
					onClose={() => setIsCoverModalOpen(false)}
					cover={cover}
					setCover={setCover}
					currentCover={book?.cover ?? ''}
					title={title}
					author={author}
				/>
			)}

			<Modal
				titleText={'책 수정하기'}
				isShowing={isOpen}
				onClose={onClose}
				size={'lg'}
				body={
					<Form onSubmit={onSubmit}>
						<div className={'clickable d-flex justify-content-center'} onClick={() => setIsCoverModalOpen(true)}>
							<BookCover
								src={cover == '' || cover == null ? BooksitoutImages.Placeholder.bookCover : cover}
								alt="Book cover"/>
						</div>
						<RowSpacer/>

						<Row>
							<Col2>
								<Form.Label>제목</Form.Label>
								<Form.Control type="text" value={title} onChange={(e) => setTitle(e.target.value)} autoComplete="off"/>
							</Col2>
							<Col2>
								<Form.Label>저자</Form.Label>
								<Form.Control type="text" value={author} onChange={(e) => setAuthor(e.target.value)} autoComplete="off"/>
							</Col2>
						</Row>
						<RowSpacer size={10}/>

						<Form.Group>
							<Form.Label>페이지</Form.Label>
							<NumberInput
								value={endPage}
								min={1}
								max={10_000}
								onChange={(e) => setEndPage(e.target.value)}
							/>
						</Form.Group>
						<RowSpacer size={10}/>

						<Form.Label>책 정보</Form.Label>
						<Row>
							<Col4>
								<BookLanguageFormSelect language={language} setLanguage={setLanguage}/>
							</Col4>
							<Col4>
								<BookFormFormSelect form={form} setForm={setForm} setSource={setSource}/>
							</Col4>
							<Col4>
								<BookSourceFormSelect form={form} source={source} setSource={setSource}/>
							</Col4>
						</Row>
						<RowSpacer/>

						<Form.Group controlId='formBasicCheckbox'>
							<Form.Check
								type='switch'
								label='내 책 정보 공개하기'
								checked={isPublic}
								onChange={() => setIsPublic(!isPublic)}
								className='force-1-line'
							/>
						</Form.Group>
						<RowSpacer size={40}/>

						<BooksitoutButton message={'책 수정하기'}/>
					</Form>
				}
			/>
		</>
	)
}

const Row = styled.div.attrs({
	className: 'row',
})`
	justify-content: right;
`

const Col2 = styled.div.attrs({
	className: 'col-12 col-md-6 mb-2 mb-md-0',
})``

const Col4 = styled.div.attrs({
	className: 'col-12 col-md-4 mb-2 mb-md-0',
})``

const BookCover = styled.img`
	height: 250px;
	border-radius: 16px;
`

export default BookEditModal
